import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import DownIcon from "assets/icons/arrow-down.svg?react";
import styles from "./styles.module.scss";
import { useWizard } from "./WizardContext";
import { IWizardStepDef } from "./typings";

interface Props {
  step: IWizardStepDef;
}

const WizardAccordionItem = ({ step }: Props) => {
  const { t } = useTranslation();
  const { currentStep, expandedStep, toggleStep } = useWizard();
  const isActive = currentStep === step.id;
  const isExpanded = expandedStep === step.id;
  const isCompleted = step.id < currentStep;
  const StepIcon = step.Icon;
  const StepComponent = step.Component;

  return (
    <div
      className={classNames(
        styles.stepItem,
        isActive && styles.active,
        isExpanded && styles.expanded,
      )}
    >
      <div
        className={styles.stepHeader}
        onClick={() => toggleStep(step.id)}
        role="button"
        aria-expanded={isExpanded}
      >
        <div
          className={classNames(
            styles.stepIcon,
            isActive && styles.activeIcon,
            isCompleted && styles.completedIcon,
          )}
          aria-hidden="true"
        >
          <StepIcon />
        </div>
        <div className={styles.stepText}>
          <div className={styles.headline}>{t(step.titleKey)}</div>
          <div className={styles.supporting}>{t(step.descriptionKey)}</div>
        </div>
        <DownIcon
          className={classNames(
            styles.chevron,
            isExpanded && styles.chevronOpen,
          )}
        />
      </div>

      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            key="content"
            className={styles.stepBodyMotion}
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: "auto", transitionEnd: { overflow: "visible" } },
              collapsed: { opacity: 0, height: 0, overflow: "hidden" },
            }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
          >
            <div className={styles.stepBody}>
              <div className={styles.stepBodyInner}>
                <StepComponent />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default WizardAccordionItem;
